import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "calendar scroll-x",
  id: "linear-calendar"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "month-selector" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "selected-month"
}
const _hoisted_7 = {
  key: 1,
  class: "selected-month"
}
const _hoisted_8 = {
  key: 2,
  class: "selected-month"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "header-right" }
const _hoisted_11 = {
  key: 0,
  class: "background"
}
const _hoisted_12 = { class: "sort-name row-header" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "title" }
const _hoisted_18 = {
  key: 0,
  class: "visibility"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "hidden"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "contents"
}
const _hoisted_23 = {
  key: 1,
  class: "contents"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "header-left")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "arrow left",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.adjustTimeframe(-1)))
          }, [
            _createElementVNode("img", { src: $setup.ArrowButtonSVG }, null, 8, _hoisted_5)
          ]),
          ($props.display === 'month')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.Months[$props.selectedDate.getMonth()]) + " " + _toDisplayString($props.selectedDate.getFullYear()), 1))
            : ($props.display === 'week')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($setup.Months[$props.selectedDate.getMonth()]) + " " + _toDisplayString($props.selectedDate.getFullYear()) + " Week " + _toDisplayString($setup.weekOfDay($props.selectedDate.getDate()) + 1), 1))
              : ($props.display === 'day')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($props.selectedDate.getDate()) + " " + _toDisplayString($setup.Months[$props.selectedDate.getMonth()]) + " " + _toDisplayString($props.selectedDate.getFullYear()), 1))
                : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: "arrow right",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.adjustTimeframe()))
          }, [
            _createElementVNode("img", { src: $setup.ArrowButtonSVG }, null, 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _renderSlot(_ctx.$slots, "header-right")
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["dates-container scroll-x scroll-y", [$setup.columnCount, {vbars: $props.sortCategory}]])
      }, [
        ($props.sortCategory )
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.daysInSelection, (i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `selection${i}`
                }))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          ($props.sortCategory === 'trainer')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Trainer"))
            : ($props.sortCategory === 'kennel')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Kennel Size"))
              : (_openBlock(), _createElementBlock("div", _hoisted_15))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.daysInSelection, (i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `dates${i}`,
            class: "dates-header"
          }, [
            _createElementVNode("div", null, _toDisplayString($setup.transformDateDay(i)), 1),
            _createElementVNode("div", null, _toDisplayString($setup.transformDateNumber(i)), 1)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.eventGroups, (group) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `group-${group.title}`
          }, [
            (group.events.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["row-header", {bigger: $props.sortCategory === 'kennel'}]),
                    onClick: ($event: any) => ($setup.groupVis[group.title] = !$setup.groupVis[group.title])
                  }, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(group.title), 1),
                    ($props.sortCategory )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("img", {
                            src: $setup.groupVis[group.title] ? $setup.VisibilityOnIcon : $setup.VisibilityOffIcon
                          }, null, 8, _hoisted_19)
                        ]))
                      : _createCommentVNode("", true),
                    (!$setup.SHOW_HIDDEN_ROWS && (!$setup.groupVis[group.title] && $props.sortCategory ))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(group.events.length) + " hidden", 1))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_16),
                  _createElementVNode("div", {
                    class: _normalizeClass(["event-container", {hbars: $props.sortCategory === 'time'}])
                  }, [
                    ($setup.groupVis[group.title] || $props.sortCategory === 'time')
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(group.events, (event) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `ge${event.event.title}`,
                            class: "event-wrapper",
                            style: _normalizeStyle($setup.buildEventCSS(event))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["event", {'uncap-left': event.startsBefore, 'uncap-right': event.endsAfter}]),
                              onClick: ($event: any) => ($setup.setTooltip(event))
                            }, [
                              (!$setup.isAllDayEvent(event.event))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(new Date(event.event.startTime).toLocaleTimeString([], {hour: 'numeric', minute: '2-digit'})) + " " + _toDisplayString(event.event.title), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(event.event.title) + " (" + _toDisplayString(event.event.startTime) + " - " + _toDisplayString(event.event.endTime) + ")", 1))
                            ], 10, _hoisted_21)
                          ], 4))
                        }), 128))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ], 2)
    ]),
    ($setup.toolTipEvent)
      ? (_openBlock(), _createBlock($setup["EventToolTip"], {
          key: 0,
          "event-detail": $setup.toolTipEvent,
          "dog-info": $setup.dogDetails($setup.toolTipEvent),
          "onClose:selectedEvent": _cache[2] || (_cache[2] = ($event: any) => ($setup.toolTipEvent = null))
        }, null, 8, ["event-detail", "dog-info"]))
      : _createCommentVNode("", true)
  ], 64))
}